<template>
  <div>
    <ZipcodeAdd
      ref="zipcodeadd"
      :state="state"
      :dialog="dialog"
      v-on:close="close()"
      v-on:save="save"
    />
    <el-card shadow="always">
      <el-row :gutter="5">
        <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
          <el-page-header
            title
            @back="$router.replace({ name: 'home' })"
            :content="$t('gerar-etiquetas')"
          ></el-page-header>
        </el-col>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          :lg="12"
          :xl="12"
          v-if="user.type === '1' || user.type === '3'"
        >
          <CustomerList
            v-model="customer"
            v-bind:current="customer"
            v-on:selected="fetchCustomer"
          />
        </el-col>
      </el-row>
    </el-card>
    <br />
    <el-card>
      <el-row :gutter="5">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("remetente") }}</span>
              <el-button
                style="float: right; padding: 5px"
                type="info"
                v-if="customer"
                icon="el-icon-plus"
                @click="open('sender')"
                >Novo</el-button
              >
            </div>
            <div>
              <el-table
                :data="tableSenders"
                ref="tableSenders"
                style="width: 100%"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="name"
                  label="Remetente"
                ></el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("destinatario") }}</span>
              <el-button
                style="float: right; padding: 5px"
                type="info"
                v-if="customer"
                icon="el-icon-plus"
                @click="open('delivery')"
                >Novo</el-button
              >
            </div>
            <div>
              <el-table
                :data="tableDelivery"
                ref="tableDelivery"
                style="width: 100%"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="name" label="Contato"></el-table-column>
                <el-table-column prop="zipcode" label="CEP">
                  <template slot-scope="scope">
                    {{ scope.row.zipcode.zipcode }}
                  </template>
                </el-table-column>
                <el-table-column prop="address" label="Endereço">
                  <template slot-scope="scope">
                    {{ scope.row.zipcode.address }}, {{ scope.row.number }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <br />
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="20%"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('modelo')" prop="model">
              <el-select v-model="ruleForm.model" placeholder="Select">
                <el-option key="1" label="Vertical" value="1"></el-option>
                <el-option key="2" label="Horizontal" value="2"></el-option>
                <el-option key="3" label="Eu Entrego" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('copias')" prop="type" class="is-required">
              <el-col :span="8">
                <el-input v-model="ruleForm.copies" type="number"></el-input>
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item
              :label="$t('ordenar')"
              prop="sortBy"
              class="is-required"
            >
              <el-select v-model="ruleForm.sortBy" placeholder="Select">
                <el-option key="1" label="Nome" value="1"></el-option>
                <el-option key="2" label="Remetente" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row :gutter="5">
        <el-col :span="24" style="text-align: center">
          <el-button type="warning" autofocus @click="submitForm('ruleForm')">{{
            $t("gerar-etiquetas")
          }}</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { TagsGenerateService } from "@/services/customers/tags.generate.services";
import { DeliveryService } from "@/services/delivery/delivery.services";
import { SendersService } from "@/services/senders/senders.services";
import { UserService } from "@/services/users/user.services";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import ZipMixins from "../../../mixins/zipcode";
import ZipcodeAdd from "./ZipcodeAdd";

export default {
  name: "TagsGenerate",
  mixins: [ZipMixins],
  components: {
    CustomerList,
    ZipcodeAdd,
  },
  methods: {
    fetchDelivery() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      DeliveryService.listByCustomer(vm.customer)
        .then((response) => {
          vm.tableDelivery = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchCustomer() {
      const vm = this;
      if (vm.customer) {
        vm.fetchSender();
        vm.fetchDelivery();
      }
    },
    submitForm(form) {
      const vm = this;

      if (
        vm.$refs.tableSenders.selection.length == 0 ||
        vm.$refs.tableDelivery.selection.length == 0
      ) {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "selecione o remetente e o destinatário",
        });
      }

      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      const destiny = [];
      for (const row of vm.$refs.tableDelivery.selection) {
        destiny.push({
          zipcode: row.zipcode.zipcode,
          name: row.name,
          address: row.zipcode.address,
          neighborhood: row.zipcode.neighborhood,
          number: row.number,
          city: row.zipcode.city,
          state: row.zipcode.state,
          complement: row.extent,
        });
      }

      const source = vm.$refs.tableSenders.selection[0];

      const data = {
        customer: vm.customer,
        source: {
          zipcode: source.zipcode,
          name: source.name,
          address: source.address,
          neighborhood: source.neighborhood,
          number: source.number,
          city: source.city,
          state: source.state,
          complement: source.complement,
        },
        destiny: destiny,
        paper: 2,
        type: vm.ruleForm.model,
        copies: vm.ruleForm.copies,
        sort: vm.ruleForm.sortBy,
      };
      TagsGenerateService.generate(data)
        .then((response) => {
          var downloadLink = document.createElement("a");
          downloadLink.href = response;
          downloadLink.download = `$carta.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          this.$message({
            type: "success",
            message: "Etiqueta gerada com sucesso!",
          });
        })
        .catch((error) => {
          this.$message({
            type: "error",
            duration: 5000,
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchSender() {
      const vm = this;
      const loading = vm.$loading({
        lock: true,
        text: i18n.tc("carregando"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      SendersService.listByCustomer(vm.customer)
        .then((response) => {
          vm.tableSenders = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    open(state) {
      const vm = this;
      vm.state = state;
      vm.$refs.zipcodeadd.open(state);
    },
    close() {
      const vm = this;
      vm.dialog = false;
    },
    save: function (record) {
      const vm = this;
      vm.dialog = false;
      const o = Object.assign({}, record)
      if (vm.state == "sender") {
        o.complement = o.extent;
        vm.tableSenders.push(o);
      } else {
        var data = {
          name: o.name,
          number: o.number,
          extent: o.extent,
          zipcode: o,
        };
        data.zipcode.zipcode = o.cep;
        vm.tableDelivery.push(data);
      }
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (response.customers) {
          vm.customer = response.customers.id;
        }
        if (vm.customer) {
          vm.fetchDelivery();
          vm.fetchSender();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      filter: "",
      tableSenders: [],
      tableDelivery: [],
      customer: "",
      dialog: false,
      state: "sender",
      ruleForm: {
        model: "1",
        copies: 1,
        sortBy: "1",
      },
      rules: {
        copies: [
          {
            required: true,
            message: "Número de cópias é obrigatório",
            trigger: "blur",
          },
        ],
      },
      user: {
        type: "2",
      },
    };
  },
};
</script>
<style>
.right {
  float: right;
}
.label {
  font-weight: bold;
}
</style>